$(document).ready(function () {
  //Carousel fix
  setTimeout(function () {
    $(".new-carousel__wrap").show();
  }, 300);


  $('.banner').owlCarousel({
    loop: true,
    nav: true,
    navText: [
      // "<img src='/client/img/home/arrow-left.png' aria-label='גלול שמאלה'>",
      // "<img src='/client/img/home/arrow-right.png' aria-label='גלול ימינה'>"
      "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 768 768'><title></title><g id='icomoon-ignore'></g><path d='M601.453 56.722c0.055 14.537-5.705 28.471-15.964 38.729l-289.097 289.536 289.097 289.645c21.284 21.34 21.284 56.009 0 77.348-21.34 21.394-55.954 21.394-77.239 0l-327.661-328.265c-21.34-21.394-21.34-56.009 0-77.348 0-0.055 0-0.055 0-0.055l327.661-328.265c21.284-21.34 55.9-21.34 77.239 0 10.204 10.258 15.964 24.192 15.964 38.675z'></path></svg>",
      "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 768 768'><title></title><g id='icomoon-ignore'></g><path d='M166.547 711.278c-0.055-14.537 5.705-28.471 15.964-38.729l289.097-289.536-289.097-289.646c-21.284-21.34-21.284-56.009 0-77.348 21.34-21.395 55.954-21.395 77.239 0l327.662 328.265c21.34 21.395 21.34 56.009 0 77.348 0 0.055 0 0.055 0 0.055l-327.662 328.265c-21.284 21.34-55.9 21.34-77.239 0-10.204-10.259-15.964-24.192-15.964-38.675z'></path></svg>"
    ],
    items: 1,
    rtl: true,
    dots: true,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true
  });

  document.querySelector(".banner").addEventListener("mouseenter", () => {
    let nav = document.querySelector(".banner .owl-nav");
    if (nav) {
      nav.style.opacity = "1";
      nav.style.visibility = "visible";
      nav.style.transition = "opacity 0.3s ease-in-out, visibility 0.3s ease-in-out";
    }
  });

  document.querySelector(".banner").addEventListener("mouseleave", () => {
    let nav = document.querySelector(".banner .owl-nav");
    if (nav) {
      nav.style.opacity = "0";
      nav.style.visibility = "hidden";
      nav.style.transition = "opacity 0.3s ease-in-out, visibility 0.3s ease-in-out";
    }
  });

  $('.goods-products').owlCarousel({
    loop: true,
    nav: true,
    navText: [
      // "<img src='/client/img/home/arrow-left.png' aria-label='גלול שמאלה'>",
      // "<img src='/client/img/home/arrow-right.png' aria-label='גלול ימינה'>"
      "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 768 768'><title></title><g id='icomoon-ignore'></g><path d='M601.453 56.722c0.055 14.537-5.705 28.471-15.964 38.729l-289.097 289.536 289.097 289.645c21.284 21.34 21.284 56.009 0 77.348-21.34 21.394-55.954 21.394-77.239 0l-327.661-328.265c-21.34-21.394-21.34-56.009 0-77.348 0-0.055 0-0.055 0-0.055l327.661-328.265c21.284-21.34 55.9-21.34 77.239 0 10.204 10.258 15.964 24.192 15.964 38.675z'></path></svg>",
      "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 768 768'><title></title><g id='icomoon-ignore'></g><path d='M166.547 711.278c-0.055-14.537 5.705-28.471 15.964-38.729l289.097-289.536-289.097-289.646c-21.284-21.34-21.284-56.009 0-77.348 21.34-21.395 55.954-21.395 77.239 0l327.662 328.265c21.34 21.395 21.34 56.009 0 77.348 0 0.055 0 0.055 0 0.055l-327.662 328.265c-21.284 21.34-55.9 21.34-77.239 0-10.204-10.259-15.964-24.192-15.964-38.675z'></path></svg>"
    ],
    items: 1,
    rtl: true,
    dots: true,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    smartSpeed: 500,
    animateOut: 'fadeOut',
  });

  document.querySelector(".goods-products").addEventListener("mouseenter", () => {
    let nav = document.querySelector(".goods-products .owl-nav");
    if (nav) {
      nav.style.opacity = "1";
      nav.style.visibility = "visible";
      nav.style.transition = "opacity 0.3s ease-in-out, visibility 0.3s ease-in-out";
    }
  });

  document.querySelector(".goods-products").addEventListener("mouseleave", () => {
    let nav = document.querySelector(".goods-products .owl-nav");
    if (nav) {
      nav.style.opacity = "0";
      nav.style.visibility = "hidden";
      nav.style.transition = "opacity 0.3s ease-in-out, visibility 0.3s ease-in-out";
    }
  });

  setTimeout(function () {
    $('.owl-carousel').each(function() {
      $(this).find('.owl-dot').each(function(index) {
        $(this).attr('aria-label', 'גלול מחוון');
      });
    });
  }, 500);

  $('.about-history__carousel').owlCarousel({
    loop: true,
    nav: true,
    navText: ["<img src='/client/img/about/arrow-left.png'>", "<img src='/client/img/about/arrow-right.png'>"],
    items: 1,
    dots: false
  })

  $('.new-carousel').owlCarousel({
    loop: true,
    nav: true,
    navText: ["<img src='/client/img/about/arrow-left-white.png' width='13' height='14' loading='lazy' aria-label=\"גלול שמאלה\">", "<img src='/client/img/about/arrow-right-white.png' width='13' height='14' loading='lazy' aria-label=\"גלול ימינה\">"],
    rtl: true,
    dots: false,
    items: 6,
    responsive: {
      320: {
        items: 2,
      },
      768: {
        items: 3,
      },
      1024: {
        items: 4,
      },
      1025: {
        items: 6,
      },
    }
  })

  $('.rec-carousel').owlCarousel({
    loop: true,
    nav: true,
    navText: ["<img src='/client/img/about/arrow-left.png'>", "<img src='/client/img/about/arrow-right.png'>"],
    rtl: true,
    dots: false,
    items: 5,
    center: true,
    margin: 10,
    responsive: {
      320: {
        items: 2,
        margin: 10,
      },
      768: {
        items: 2,
        margin: 10,
      },
      1024: {
        margin: 10,
        items: 5,
      },
      1025: {
        margin: 10,
        items: 5,
      },
    }
  })

  $('.categories-carousel').owlCarousel({
    loop: true,
    nav: false,
    items: 5,
    rtl: true,
    center: true,
    autoWidth: true,
    dots: false
  })

  $('.feed-filter__item').click(function (e) {
    const group = $(this).data('group');
    const hsid = $(this).data('hsid');

    $(`.feed-filter__item[data-group=${group}]`).removeClass('active')
    $(`.feed-filter__item[data-group=${group}][data-hsid=${hsid}]`).addClass('active')

    $(`.feed__items__wrapper[data-group=${group}]`).removeClass('active')
    $(`.feed__items__wrapper[data-group=${group}][data-hsid=${hsid}]`).addClass('active')
  })

  /*var galleryThumbs = new Swiper(".product-gallery__thumb", {
      slidesPerView: 5,
      loop: true,
      autoHeight: true,
      breakpoints: {
          320: {
              direction: 'horizontal',
          },
          481: {
              direction: 'vertical',
          },
      }
  });

  var galleryMain = new Swiper(".product-gallery", {
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      preventInteractionOnTransition: true,
      loop: true,
      navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
      },
      effect: 'fade',
      fadeEffect: {
          crossFade: true
      },
      thumbs: {
          swiper: galleryThumbs
      }
  });

  galleryMain.on('slideChangeTransitionStart', function() {
      galleryThumbs.slideTo(galleryMain.activeIndex);
  });

  galleryThumbs.on('transitionStart', function(){
      galleryMain.slideTo(galleryThumbs.activeIndex);
  });*/
})
